module.exports = __webpack_public_path__ + "img/icon-chat-blue.4bcdb048.svg";